import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { mooresvilleConfig } from "./data";

export default function MooresvillePage() {
  return <CityPageTemplate config={mooresvilleConfig} />;
}